import isNumber from 'lodash.isnumber';

type Props = {
    currentPage?: number,
    pageSize?: number,
    index?: number,
};

export const getPaginatedRowNumber = ({currentPage, pageSize, index}: Props) => (
    isNumber(currentPage) && isNumber(pageSize) && isNumber(index)
        ? (currentPage - 1) * pageSize + index
        : 0
);
